module.exports = __webpack_public_path__ + "img/ab1t3.44d2ad33.png";